$(document).ready(function() {
  'use strict';

  var currencySymbols = {
    NZD: '$',
    AUD: '$',
    USD: '$',
    GBP: '£'
  }
  
  var customerTags = window.customerTags;
  
  var isUSD = $.inArray('USD', customerTags);
  
  // Set currency to USD for USD Trade customers
  if (isUSD > -1) {
    $('.custom-selected-currency').text('USD');
    $('#custom-currencies').val('USD');
    $('#custom-currencies').change();
    setCookie('customCurrency', 'USD', 30);
  }

  var currencyCookie = getCookie('customCurrency');
  if (!currencyCookie) {
    currencyCookie = 'NZD';
  }
  var currency = currencyCookie ? currencyCookie : 'NZD';
  var isTrade = $.inArray('Trade', customerTags);

  // Set cookie
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  // Get cookie
  function getCookie(cookiename) {
    var cookiestring=RegExp(""+cookiename+"[^;]+").exec(document.cookie);
    return unescape(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./,"") : "");
  }

  // Set default cookie
  if (!currencyCookie) {
    setCookie('customCurrency', 'NZD', 30);
  }

  // Filter Trade prices
  function filterTradePrices() {
    // Trade
    if (isTrade > -1) {
      $('.wrapper-Size select option, .wrapper-Unit select option, .wrapper-Grade select option, .wrapper-Composition select option').each(function() {
        if ($(this).val().indexOf('Trade') === -1) {
          $(this).remove();
        }
      });
      $('.product-options-Size div, .product-options-Unit div, .product-options-Grade div, .product-options-Composition div').each(function() {
        if ($(this).text().indexOf('Trade') === -1) {
          $(this).remove();
        }
      });
    }
    // Not trade
    else {
      $('.wrapper-Size select option, .wrapper-Unit select option, .wrapper-Grade select option, .wrapper-Composition select option').each(function() {
        if ($(this).val().indexOf('Trade') !== -1) {
          $(this).remove();
        }
      });
      $('.product-options-Size div, .product-options-Unit div, .product-options-Grade div, .product-options-Composition div').each(function() {
        if ($(this).text().indexOf('Trade') !== -1) {
          $(this).remove();
        }
      });
      $('.wrapper-Pricing select option').each(function() {
        if ($(this).val().indexOf(':0.00') !== -1) {
//           $(this).remove();
        }
      });
    }
    $('.wrapper-Size select, .wrapper-Unit select, .wrapper-Grade select, .wrapper-Composition select').change();
  }

  filterTradePrices();

  // Filter options
  function filterOptions() {
    /*if (currencyCookie == 'USD') {
      $('.wrapper-Unit select option, .wrapper-Size select option').each(function() {
        if ($(this).val().indexOf('yard') === -1 && $(this).val().indexOf('foot') === -1 && $(this).text().indexOf('ample') === -1) {
          $(this).remove();
        }
      });
      $('.product-options-Unit div, .product-options-Size div').each(function() {
        if ($(this).text().indexOf('yard') === -1 && $(this).text().indexOf('foot') === -1 && $(this).text().indexOf('ample') === -1) {
          $(this).remove();
        }
      });
    }
    if (currencyCookie == 'NZD') {
      $('.wrapper-Unit select option, .wrapper-Size select option').each(function() {
        if ($(this).val().indexOf('metre') === -1 && $(this).text().indexOf('ample') === -1) {
          $(this).remove();
        }
      });
      $('.product-options-Unit div, .product-options-Size div').each(function() {
        if ($(this).text().indexOf('metre') === -1 && $(this).text().indexOf('ample') === -1) {
          $(this).remove();
        }
      });
    }*/
    if (currencyCookie == 'USD') {
      $('.wrapper-Unit select option, .wrapper-Size select option').each(function() {
        if ($(this).val().indexOf('metre') !== -1) {
          $(this).remove();
        }
      });
      $('.product-options-Unit div, .product-options-Size div').each(function() {
        if ($(this).text().indexOf('metre') !== -1) {
          $(this).remove();
        }
      });
    }
    if (currencyCookie == 'NZD') {
      $('.wrapper-Unit select option, .wrapper-Size select option').each(function() {
        if ($(this).val().indexOf('yard') !== -1 || $(this).val().indexOf('foot') !== -1) {
          $(this).remove();
        }
      });
      $('.product-options-Unit div, .product-options-Size div').each(function() {
        if ($(this).text().indexOf('yard') !== -1 || $(this).text().indexOf('foot') !== -1) {
          $(this).remove();
        }
      });
    }
    $('.wrapper-Size select, .wrapper-Unit select, .wrapper-Grade select, .wrapper-Composition select').change();
  }

  filterOptions();
  
  function checkForPOA(productId, currency, priceClass, selectedOption = null) {
    var selected = $('.product-variants').find(':selected').text();
    if ($('[data-product-id="' + productId + '"]').data('poa') && (selectedOption && selected.indexOf('ample') === -1)) {
      $('[data-product-id="' + productId + '"]' + ' .' + priceClass).text('POA');
      $('[data-product-id="' + productId + '"]' + ' .add-to-cart').html('<a class="button" href="mailto:mail@emmahayestextiles.com">Enquire</a>');
    }
    else {
      var price = $('.main-product-wrap').data('price-' + currency.toLowerCase());
      if (price) {
        price = price.toString().split(':');
        if (typeof price[1] !== 'undefined') {
          price = price[1];
        }
        else {
          price = price[0];
        }
        price = parseFloat(price).toFixed(2);
        $('[data-product-id="' + productId + '"]' + ' .' + priceClass).text('$' + price + ' ' + currency);
        $('[data-product-id="' + productId + '"]' + ' .add-to-cart').html('<input type="submit" value="Add to cart">');
      }
    }
  }
  
  function checkForPreOrder(productId, currency, priceClass) {
    if ($('[data-product-id="' + productId + '"]').data('pre-order')) {
      $('[data-product-id="' + productId + '"]' + ' .add-to-cart').html('<a class="button" href="mailto:mail@emmahayestextiles.com?subject=Pre order enquiry for ' + $('.product-title').text() + '">Available to pre-order</a>');
    }
  }

  // Update pricing
  function updateCurrency(productId, price, currency, priceClass) {
    $('.wrapper-Pricing select').val(currency);
    $('.wrapper-Pricing select option').filter(function() {
      return $(this).text().indexOf(currency) === 0;
    }).prop('selected', true);
    $('.wrapper-Pricing select').change();
    $('[data-product-id="' + productId + '"]' + ' .' + priceClass).text(currencySymbols[currency] + price + ' ' + currency);
    checkForPOA(productId, currency, priceClass);
    checkForPreOrder(productId, currency, priceClass);
  }

  // Currency changer
  $('#custom-currencies').change(function() {
    setCookie('customCurrency', $(this).val(), 30);
    window.location.reload(false);
  });
  $('#custom-currencies').val(currency);
  $('.custom-selected-currency').text(currency);

  // Collection products
  if ($('.collection-products').length > 0) {
    $('.product-list-item').each(function() {
      var productId = $(this).data('product-id');
      var price = $(this).data('price-' + currency.toLowerCase());
      if (price) {
        price = parseFloat(price.toString().replace(/[^0-9\.]/g,'')).toFixed(2);
        updateCurrency(productId, price, currency, 'money');
      }
    });
  }

  // Related products
  if ($('.related-products-wrapper').length > 0) {
    $('.product-list-item').each(function() {
      var productId = $(this).data('product-id');
      var price = $(this).data('price-' + currency.toLowerCase());
      if (price) {
        price = parseFloat(price.toString().replace(/[^0-9\.]/g,'')).toFixed(2);
        $('[data-product-id="' + productId + '"]' + ' .money').text(currencySymbols[currency] + price + ' ' + currency);
      }
    });
  }

  // Main product
  if ($('.main-product-wrap').length > 0) {
    var productId = $('.main-product-wrap').data('product-id');
    var price = $('.main-product-wrap').data('price-' + currency.toLowerCase()).toString();
    if (price) {
      setTimeout(function() {
        price = parseFloat(price.toString().replace(/[^0-9\.]/g,'')).toFixed(2);
        var selectedText = $('.product-option.selected').text().toLowerCase();
        $('[data-product-id="' + productId + '"]' + ' .money').text(currencySymbols[currency] + price.toString() + ' ' + currency);
        checkForPOA(productId, currency, 'money', selectedText);
        checkForPreOrder(productId, currency, 'money');
        $('.money').show();
      }, 500);
    }
  }

  $('.wrapper-Size select, .wrapper-Unit select, .wrapper-Grade select, .wrapper-Composition select').change(function() {
    $('.money').hide();
    var productId = $('.main-product-wrap').data('product-id');
    var price = $('.main-product-wrap').data('price-' + currency.toLowerCase()).toString();
    if (price) {
      setTimeout(function() {
        var priceOrig = price;
        price = parseFloat(price.toString().replace(/[^0-9\.]/g,'')).toFixed(2);
        var selectedText = $('.product-option.selected').text().toLowerCase();
        $('[data-product-id="' + productId + '"]' + ' .money').text(currencySymbols[currency] + price.toString() + ' ' + currency);
        checkForPOA(productId, currency, 'money', selectedText);
        checkForPreOrder(productId, currency, 'money');
        $('.money').show();
        $('.product-options-Pricing').find(`[data-option='${priceOrig}']`).click();
      }, 500);
    }
  });
  
  $('.product-option').click(function() {
    var selectedText = $(this).text().toLowerCase();
    var productId = $('.main-product-wrap').data('product-id');
    var price = $('.main-product-wrap').data('price-' + currency.toLowerCase()).toString();
	checkForPOA(productId, currency, 'money', selectedText);
  });
  
  $('.product-options .selector-wrapper').each(function() {
    var selectedText = $(this).find('.selected-text').text();
    $('.product-option:contains(' + selectedText + ')').addClass('selected');
    $('.product-options .selected').click();
  });
  
});